
        
<template>
  <div id="signup" class="signup">
    <div id="steps" class="col-12">
      
      <div v-if="$route.params.step == 'welcome'" class="step">
        <h3>Primeiros passos</h3>

        <text-field
          label="Nome da empresa"
          type="text"
          v-model="tradingName"
          :validations="$v.tradingName"
          @keyup.enter.native="evtNextStep"
        ></text-field>

        <text-field
          label="Selecione a quantidade de licenças"
          type="number"
          value="1"
          minvalue="1"
          step="1"
          maxvalue="200"
          onkeydown="return event.keyCode !== 69 && event.keyCode !== 189&& event.keyCode !== 190"
          v-model="licences"
          :validations="$v.licences"
          @keyup.enter.native="evtNextStep"
        ></text-field>

        <template v-if="platform == 'task'">

          <p>
            Uma licença dá a um usuário o direito de acesso a todas os recursos do
            plano contratado.
          </p>

          <div class="billing">
            <div class="title">{{ `Plano ${selectedPlan.description} - ${licences > 3 ? 'a partir de 4 licenças' : 'até 3 licenças'}` }}</div>

            <div v-if="licences > 3">
              <div class="price">R$ {{ selectedPlan.pricing }} por usuário por mês</div>
              <div class="taxes">Acesso completo durante o período de experimentação de 7 dias</div>
              <div class="taxes"><b>Não necessário informar cartão de crédito</b></div>
            </div>

            <div class="features">
              <h4>Recursos</h4>

              <ul>
                <li v-for="(resource, index) in selectedPlan.resources"
                  :key="`task-resources-${index}`">
                  {{ resource }}
                </li>
              </ul>
            </div>

          </div>

        </template>

        <template
          v-if="platform == 'echo'">

          <p>
            Use o Echo para conversar com sua equipe. Cada licença dá acesso a todos 
            os recursos.
          </p>

          <div class="billing">
            
            <div class="title">Echo</div>

            <div class="price">R$ 349,00 por mês</div>
            <div class="taxes">*Valores de mensagens Whatsapp diretamente com a API de Integração com Meta Business.</div>            

            <div class="features">
              <h4>Recursos</h4>

              <ul>
                <li>40 usuários</li>
                <li>5 números de whatsapp</li>
                <li>Assistente Virtual com ChatGPT 4</li>
                <li>Integração com Whatsapp*</li>
                <li>Chat Embarcado para Aplicativos e Sites</li>
                <li>Disparo de mensagens em massa</li>                
                <li>Chat interno para sua equipe</li>
                <li>Suporte por telefone, e-mail e whatsapp</li>
              </ul>
            </div>

          </div>

        </template>

        <template
          v-if="platform == 'react'">

          <p>
            Use o React para aprimorar sua experiência com seus clientes e colaboradores. Cada licença dá
            acesso a todos os recursos.
          </p>

          <div class="billing">
            <div v-if="plan == 'basic'">
              <div class="title">Básico</div>
              <div class="price">$ 4.99 dólares por mês, por usuário</div>
            </div>      
            
            <div v-if="plan == 'grow'">
              <div class="title">Cresça</div>
              <div class="price">$ 12.99 dólares por mês, por usuário</div>
            </div> 

            <div v-if="plan == 'scale'">
              <div class="title">Escale</div>
              <div class="price">$ 19.99 dólares por mês, por usuário</div>
            </div>

            <div class="features">
              <h4>Recursos</h4>

              <ul>
                <li v-if="plan == 'basic'"><b>Até 1.000 respostas por mês</b></li>
                <li v-if="plan == 'grow'"><b>Até 10.000 respostas por mês</b></li>
                <li v-if="plan == 'scale'"><b>Respostas ilimitadas</b></li>
                <li>Formulários com protocolo</li>
                <li>Respostas com inteligência artificial</li>
                <li>Formulários personalizados</li>
                <li>Integrado ao Echo e Task</li>
                <li>Relatórios e Dashboards</li>
                <li>API para integrações</li>
                <li>Conte com o suporte da TARS por telefone, e-mail e whatsapp</li>
              </ul>
            </div>

          </div>

        </template>
      </div>

      <div v-if="$route.params.step == 'contactinfo'" class="step">
        <h3>Informações do usuário administrador</h3>

        <p>
          Você será o administrador da conta do TARS One porque está criando a
          conta.          
        </p>
        
        <text-field
          label="Endereço de e-mail"
          type="email"
          v-model="userMail"
          :validations="$v.userMail"
          v-on:blur="checkEmail"
          @keyup.enter.native="evtNextStep"
        ></text-field>        

        <text-field
          label="Nome completo"
          type="text"
          v-model="userName"
          :validations="$v.userName"
          @keyup.enter.native="evtNextStep"
        ></text-field>

        <text-field
            label="Telefone de contato"
            type="text"
            v-bind:mask="['(##) ####-####', '(##) #####-####']"
            v-model="phoneContact"
            :validations="$v.phoneContact"
            @keyup.enter.native="evtNextStep"
          ></text-field>

        <div id="read-accept">
          <div id="message">
            <span>
              Ao clicar em
              <b>Concordar e continuar</b>, você aceita os
            </span>
            <span class="terms">
              <a href="http://tars.com.br/terms/terms-of-service" target="_blank">Termos de Serviço da TARS</a>, os
              <a href="http://localhost:3000/terms/product-specific" target="_blank">Termos de Produtos Específicos</a> relacionados ao produto que esta sendo contratado neste formulário, e a 
              <a href="http://tars.com.br/terms/privacy-policy" target="_blank">Política de Privacidade</a>.
            </span>            
          </div>
        </div>
          
      </div>

      <div v-if="$route.params.step == 'conditions'" class="step">
        <Terms></Terms>

        <div id="read-accept">
          <div id="message">
            <span>
              Ao clicar em
              <b>Concordar e continuar</b>, você aceita o
            </span>
            <span class="terms"
              >Termo de Adesão de uso e política de compra TARS One</span
            >
            <span>descrito acima.</span>
          </div>
        </div>
      </div>

      <div v-if="$route.params.step == 'billinginfo'" class="step">
        <h3>Dados de faturamento</h3>

        <div>
          <text-field
            label="CPF / CNPJ"
            type="text"
            v-bind:mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="document"
            :validations="$v.document"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <div>
          <text-field
            label="Nome / Razão Social"
            type="text"
            v-model="companyName"
            :validations="$v.companyName"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <div>
          <text-field
            label="CEP"
            type="text"
            v-model="zip"
            :validations="$v.zip"
            v-bind:mask="['##.###-###']"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <div class="field-group">
          <text-field
            class="flex-2"
            label="Rua"
            type="text"
            v-model="addressStreet"
            :validations="$v.addressStreet"
            @keyup.enter.native="evtNextStep"
          ></text-field>

          <text-field
            class="flex-1"
            label="Número"
            type="text"
            v-model="addressNumber"
            :validations="$v.addressNumber"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <div class="field-group">
          <text-field
            class="flex-1"
            label="Complemento"
            type="text"
            v-model="addressComplement"
            @keyup.enter.native="evtNextStep"
          ></text-field>

          <text-field
            class="flex-1"
            label="Bairro"
            type="text"
            v-model="addressDistrict"
            :validations="$v.addressDistrict"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <div class="row"
          data-app>

          <div class="col-4">

            <v-select
              class="v-select-customized"
              :items="this.$store.state.signup.states"
              label="Estado"
              item-text="tstname"
              item-value="tstid"
              v-model="addressState"
              :validations="$v.addressState"
              :menu-props="{ bottom: true, offsetY: true }"
              @input="onStateChange"
              @keyup.enter.native="evtNextStep"
              dense
            ></v-select>
          
          </div>

          <div class="col-8"> 

            <v-select
              class="v-select-customized"
              :items="this.$store.state.signup.choosenCities"
              label="Cidade"
              item-text="tciname"
              item-value="tciid"
              v-model="addressCity"
              :validations="$v.addressCity"
              :menu-props="{ bottom: true, offsetY: true }"
              @input="onCityChange"
              @keyup.enter.native="evtNextStep"
              dense
            ></v-select>

          </div>

        </div>
        
      </div>

      <div v-if="$route.params.step == 'checkout'" class="step">
        <h4>
          Você está autorizando a cobrança do TARS One. As condições completas e
          o termo estão disponíveis
          <a style="color: blue" @click="openModal">clicando aqui</a>
        </h4>

        <div>
          <modal-direction
            v-model="modalOpen"
            v-if="modalOpen"
          ></modal-direction>
        </div>

        <div style="overflow: hidden; position: relative">
          <text-field
            label="Cartão"
            v-model="cardNumber"
            :validations="$v.cardNumber"
            v-bind:mask="[
              '#### #### #### ####',
              '#### ###### #####',
              '#### #### #### #### #### ####',
            ]"
            @input="onCardNumberChange"
            @keyup.enter.native="evtNextStep"
          ></text-field>
        </div>

        <text-field
          label="Nome"
          v-model="cardHolder"
          :validations="$v.cardHolder"
          maxlength="30"
          isUpper
          @keyup.enter.native="evtNextStep"
        ></text-field>

        <text-field
          label="Mês/Ano"
          v-model="cardExpiringDate"
          :validations="$v.cardExpiringDate"
          type="text"
          v-bind:mask="['##/##']"
          @keyup.enter.native="evtNextStep"
        ></text-field>
        <text-field
          label="CVC"
          v-model="cardCVC"
          :validations="$v.cardCVC"
          myValidate="cardCVC"
          v-bind:mask="[this.cvcMask]"
          @keyup.enter.native="evtNextStep"
        ></text-field>
      </div>

      <div id="bottom-buttons">
        <div id="forward-button" v-if="boolShowButtonNextStep">
          <button
            class="button forward-button"
            v-if="
              $route.params.step == 'welcome'
            "
            v-on:click="evtNextStep"
          >
            PRÓXIMA
          </button>
          <button
            class="button forward-button"
            v-if="
              $route.params.step != 'conditions' &&
              $route.params.step == 'billinginfo'
            "
            v-on:click="evtNextStep"
          >
            CONTRATAR
          </button>
          <button
            class="button forward-button"
            v-if="$route.params.step == 'conditions'"
            v-on:click="evtNextStep"
          >
            CONCORDAR E CONTINUAR
          </button>
          <button
            class="button forward-button"
            v-if="$route.params.step == 'contactinfo'"
            v-on:click="evtNextStep"
          >
            CONCORDAR E CONTINUAR
          </button>
        </div>
        <div id="back-button" v-if="boolShowButtonNextStep && $route.params.step != 'welcome'">
          <button v-on:click="evtGoBack" 
            class="button back-button">
            <i class="fas fa-arrow-left"></i>
          </button>
        </div>
      </div>

      <div class="get-ready" v-if="$route.params.step == 'login'">
        <div id="app-loader" v-if="this.$store.state.caller.isLoading">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <h3>{{ this.$store.state.signup.checkoutMessage }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/* eslint-enable */
import "@/assets/global.scss";
import TextField from "@/components/TextField.vue";
import ModalDirection from "@/components/Modal.vue";
import { required, email, minValue, maxValue,  sameAs } from "vuelidate/lib/validators";
import {
  cardNumber,
  cardExpiringDate,
  cardCVC,
  masks,
  brazilianDocument,
  customRequired,
  emailIsUsed,
} from "@/lib/validations.js";
import { _utils } from "@/lib/utils.js";

const axios = require("axios").default;

const signupSteps = [
  { id: 1, name: "welcome" },
  { id: 2, name: "contactinfo" },
  { id: 3, name: "login" },
];

export default {
  name: "signup",
  components: {
    TextField,
    //SelectField,
    ModalDirection,
  },
  data: function () {
    return {
      boolShowButtonNextStep: true,
      boolShowButtonHire: true,
      acceptTerms: false,
      modalOpen: false,
      tradingName: "",
      companyName: "",
      userName: "",
      userMail: "",
      licences: "",
      document: "",
      name: "",
      zip: "",
      address: "",
      addressNumber: "",
      addressComplement: "",
      addressStreet: "",
      addressDistrict: "",
      addressState: {
        type: Object,
        default: {},
      },
      addressCity: {
        type: Object,
        default: {},
      },
      phoneContact: "",
      cardNumber: "",
      cardHolder: "",
      cardExpiringDate: "",
      cardCVC: "",
      cvcMask: "####",
      platform: this.$route.params.platform,
      plan: this.$route.params.plan,
      plans: [
        { 
          value: 'free', 
          pricing: 0, 
          description: 'Gratuito',
          resources: [
            'Quadros', 'Dashboards', 'Lista de Tarefas', 'Menu Administrador'
          ]
        },
        { 
          value: 'team', 
          pricing: 39.9, 
          description: 'Equipes',
          resources: [
            'Tudo do plano Gratuito', 'Modelos de Tarefas', 'Controle de Clientes', 'Relatórios',
            'Configurações Personalizadas', 'Automações', 'Integração com Google Agenda', 
            'Rastreio de Tempo', 'Suporte Whatsapp/Telefone'
          ]
        },
        { 
          value: 'pro', 
          pricing: 45.9, 
          description: 'Profissional',
          resources: [
            'Tudo do plano Equipes', 'Controle de Serviços', 'Painel de Clientes', 'Usuários de Clientes/Fornecedores', 'Implantação com a TARS'
          ]
        }
      ]
    };
  },
  watch: {
    licences: function(/*newLicences*/) {
      /*if (newLicences > 3) 
        this.plan = 'team'
      else this.plan = 'free'*/
    },
    zip: function (newZip) {
      if (newZip.length == 10) {
        axios
          .get(
            "https://viacep.com.br/ws/" +
              newZip.replace(".", "").replace("-", "") +
              "/json/"
          )
          .then(this.evtPopulateAddress);
      }
    },
  },
  methods: {
    moneyFormat(price, sign = "R$ ") {
      const pieces = parseFloat(price).toFixed(2).split("");
      let piece = pieces.length - 3;
      while ((piece -= 3) > 0) {
        pieces.splice(piece, 0, ",");
      }
      return sign + pieces.join("").replace(".", ",");
    },
    openModal() {
      this.modalOpen = !this.modalOpen;
    },
    onStateChange: function (state, searchCity) {
      
      let selectedState = this.$store.state.signup.states.find(f => f.tstid == state)

      this.$store.dispatch("signup/chooseState", selectedState);
      
      if (this.$store.state.signup.state == null) return [];
      let cities = [];
      for (let key in this.$store.state.signup.cities) {
        if (
          this.$store.state.signup.cities[key].tcitstid ==
          this.$store.state.signup.state.tstid
        ) {
          cities.push(this.$store.state.signup.cities[key]);
        }
      }
      
      this.$store.dispatch("signup/chooseCities", cities);

      if (searchCity != undefined) {
        this.addressCity = this.$store.state.signup.cities.find(
          (f) => f.tciname == searchCity
        );

        this.onCityChange(this.addressCity.tciid);
      }
    },
    onCityChange: function (city) {

      let selectedCity = this.$store.state.signup.cities.find(f => f.tciid == city)

      this.$store.dispatch("signup/chooseCity", selectedCity);
    },

    onCardNumberChange: function (number) {
      let valid = require("card-validator");
      let numberValidation = valid.number(number);
      if (!numberValidation.isPotentiallyValid) {
        if (numberValidation.card) {
          this.$data.cvcMask = "#".repeat(numberValidation.card.code.size);
        }
      }
    },

    evtPopulateAddress: function (response) {
      this.addressStreet = response.data.logradouro;
      this.addressDistrict = response.data.bairro;

      this.addressState = this.$store.state.signup.states.find(
        (f) => f.tstinitials == response.data.uf
      );

      this.onStateChange(this.addressState.tstid, response.data.localidade);
    },

    evtCheckout: async function () {
      this.$store.dispatch(
        "signup/setUser",
        getUserFromSignUpData(this.$data, this.$store.state)
      );
      this.$store.dispatch(
        "signup/setCheckoutMessage",
        "Aguarde enquanto confirmamos os seus dados."
      );
      await this.$store.dispatch("signup/checkout");

      if (!this.$store.state.signup.checkoutOk) {
        this.evtGoBack();
      }
    },

    evtStartTrial: async function () {

      this.$store.dispatch(
        "signup/setUser",
        getUserFromSignUpData(this.$data, this.$store.state)
      );
      this.$store.dispatch(
        "signup/setCheckoutMessage",
        "Aguarde enquanto confirmamos os seus dados."
      );
      await this.$store.dispatch("signup/changeBlankDB");

    },

    evtNextStep: function () {
      
      var currentRoute = signupSteps.filter(
        (x) => x.name == this.$route.params.step
      )[0];

      if (!this.evtCheckForm(currentRoute.name)) return;

      var nextRoute = signupSteps.filter((x) => x.id == currentRoute.id + 1)[0];
      
      this.$router.push(`/signup/${this.platform}/${this.plan}/${nextRoute.name}`);

      if (nextRoute.name == 'login') {    
        this.boolShowButtonNextStep = false;    
        this.evtInsertLead();
        this.acceptTerms = true;
        this.evtStartTrial();
      }

      this.evtRouteChanged();

    },
    evtInsertLead: function () {

      this.$store.dispatch("lead/insert", {
        data: this.evtGetPartialForm()
      }); 

    },
    evtGetPartialForm: function() {

      let partialForm = {
        Name: this.$data.userName,
        Email: this.$data.userMail,
        Company: this.$data.tradingName,
        Quantity: this.$data.licences,
        Phone: this.$data.phoneContact
      };

      return partialForm
    },
    evtGoBack: function () {
      
      window.history.length > 1 ? 
        this.$router.go(-1) : 
        this.$router.push("/");

      this.boolShowButtonNextStep = true;
      this.evtRouteChanged();
    },
    evtRouteChanged: function () {
      _utils.actions.focusOnFirstField(".step");
    },
    evtCheckForm: function (route) {
      var formValid = true;
      var parent = this; // eslint-disable-line
      function touch(fields) {
        fields.forEach((field) => {
          eval("parent.$v." + field + ".$touch()");
          if (eval("parent.$v." + field + ".$error") === true) {
            formValid = false;
          }
        });
      }

      if (route == "welcome") {
        touch(["tradingName", "licences"]);
      } else if (route == "contactinfo") {
        touch(["userName"]);
        touch(["userMail"]);
        touch(["phoneContact"]);
        if (this.$store.state.signup.userExists) formValid = false;
      } else if (route == "billinginfo") {
        touch([
          "document",
          "companyName",
          "zip",
          "addressStreet",
          "addressNumber",
          "addressDistrict",
          "addressState",
          "addressCity"
        ]);
      } else if (route == "checkout") {
        touch(["cardHolder", "cardNumber", "cardExpiringDate", "cardCVC"]);
      }
      return formValid;
    },
    checkEmail: async function () {
      await this.$v.userMail.$touch();
    },
  },

  validations: {
    tradingName: { required },
    companyName: { required },
    userName: { required },
    userMail: { required, email, emailIsUsed },
    licences: { required, minValue: minValue(1), maxValue: maxValue(200) },
    document: {
      required,
      brazilianDocument,
      masks: masks(["###.###.###-##", "##.###.###/####-##"]),
    },
    name: { required },
    zip: { required, masks: masks(["##.###-###"]) },
    addressStreet: { required },
    addressNumber: { required },
    addressDistrict: { required },
    addressState: { customRequired: customRequired("tstid") },
    addressCity: { customRequired: customRequired("tciid") },
    phoneContact: { required },
    cardNumber: { required, cardNumber },
    cardHolder: { required },
    cardExpiringDate: { required, cardExpiringDate },
    cardCVC: { required, cardCVC },
    acceptTerms: { sameAs: sameAs(() => true) },
  },

  computed: {
    selectedPlan() {
      let plan = this.plans.find(f => f.value == this.plan)
      
      return plan
    }
  },

  beforeCreate: function () {
    if (this.$route.params.step != "welcome")
      this.$router.replace(`/signup/${this.platform}/${this.plan}/welcome`);  
    
    if (!['react','task','echo'].includes(this.$route.params.platform))
      location.href = 'https://tars.com.br'

    let reactPlans = ['basic','grow','scale']
    let echoPlans = ['basic']

    if (this.$route.params.platform == 'react' &&
      !reactPlans.includes(this.$route.params.plan)
    ) location.ref = 'https://one.tars.com.br/signup/react/basic/welcome'

    if (this.$route.params.platform == 'echo' &&
      !echoPlans.includes(this.$route.params.plan)
    ) location.ref = 'https://one.tars.com.br/signup/echo/basic/welcome'

    

  },

  mounted: async function () {
    
    _utils.actions.focusOnFirstField(".step");

    if (this.$store.state.signup.UserCode == null) {
      await this.$store.dispatch("signup/getUserCode");
    }

    if (this.$store.state.signup.businessPlans[0] == null) {
      this.$store.dispatch("signup/getBusinessPlans", {});
    }

    if (this.$store.state.signup.ip == null) {
      await this.$store.dispatch("signup/setIP");
    }

    if (this.$store.state.signup.cities.length == 0) {
      await this.$store.dispatch("signup/populateSignupData", {
        selection: "cities",
      });
    }
    if (this.$store.state.signup.states.length == 0) {
      await this.$store.dispatch("signup/populateSignupData", {
        selection: "states",
      });
    }
  },
};

function getUserFromSignUpData(sData, state) {
  
  return {
    ProfileID: null,
    EntityType: "F",
    Name: sData.userName,
    CompanyName: sData.tradingName,
    TradingName: sData.tradingName,
    BirthDate: null,
    Nationality: "1",
    CountryID: "1",
    TaxRegimeID: null,    
    Emails: sData.userMail,
    Document: null,
    Phones: sData.phoneContact,
    SoftDescriptor: "TARSOne_ECommerce",
    Platform: sData.platform,
    PaymentAddress: {
      ZIPCode: null,
      Address: null,
      Number: null,
      Complement: null,
      CityID: null,
      InternationalCityName: null,
      InternationalStateName: null,
      IsInternationalPurchase: false,
      AddressDistrict: null,
    },
    Subscription: {
      Pricing: state.signup.businessPlans[0].TbpPrice,
      Quantity: sData.licences,
      BusinessPlanID: state.signup.businessPlans[0].TbpID,
      ServiceID: state.signup.businessPlans[0].TbptasID,
      PaymentCondition:
        "1x - R$ " +
        sData.licences * state.signup.businessPlans[0].TbpPrice +
        " (S/juros)",
      ContactOrigin: "tarsone",
      ContactMethod: "tarsone",
      PaymentMethod: "cartao_credito",
      Observation: "Inscrição originada pelo e-commerce TARSOne",
      SubscriptionObservation: "Inscrição originada pelo e-commerce TARSOne",
      IntervalCount: state.signup.businessPlans[0].tbpIntervalCount,
      Interval: state.signup.businessPlans[0].tbpInterval,
      IntervalDescription:
        state.signup.businessPlans[0].tbpIntervalCount +
        " " +
        state.signup.businessPlans[0].tbpInterval,
      VoucherCode: null,
      ContractID: state.signup.contract.TciID,
      IPContractAccept: state.signup.ip,
      DiscountType: 0,
      Discount: 0
    },
    CompanyCode: "1221",
    UserCode: state.signup.UserCode,
    InvoiceEmailSender: sData.userMail,
    Language: "pt",
  };
}
</script>

<style lang="scss">
@import "~vuejs-noty/dist/vuejs-noty.css";

#signup {
  display: flex;
  margin: 15px;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  #steps {
    flex: 1;

    .title {
      font-weight: 400;
      font-size: 35px;
      border-bottom: 1px solid #ddd;
    }

    .step {
      margin-top: 20px;

      h3 {
        font-weight: 400;
        font-size: 18px;
      }

      h4 {
        font-weight: 500;
        font-size: 16px;
        color: #666;
        margin-top: 20px;

        a {
          cursor: pointer;
        }

        a:hover {
          color: deepskyblue;
        }
      }

      p {
        font-size: 13px;
        color: #999;
        margin-bottom: 0;
      }

      .field-group {
        display: flex;

        .flex-1 {
          flex: 1;
        }

        .flex-2 {
          flex: 2;
        }
      }

      #read-accept {
        margin-top: 20px;
        height: 30px;

        #message {
          font-size: 13px;
          line-height: 20px;

          .terms {
            color: #108f65;
            font-weight: 500;
          }
        }
      }

      .billing {
        padding-right: 20px;
        margin-top: 20px;
        text-align: left;

        div {
          margin-bottom: 5px;
          text-align: left;
        }

        .promo {
            text-align: center;
            height: 55px;
            line-height: 55px;
            width: 90px;
            position: absolute;
            left: -45px;
            top: 11px;
            font-size: 12px;
            font-weight: 450;
            color: #fff;
            background-color: rgb(36, 192, 116);
            border-radius: 3px;
        }

        .title {
          font-weight: 500;
          font-size: 14px;
        }

        .price {
          font-size: 18px;
          font-weight: 300;
        }

        .payment {
          font-size: 14px;
        }

        .taxes {
          font-size: 12px;
        }

        .start {
          border-radius: 3px;
          transition: background-color 0.2s;
          cursor: pointer;
          margin-top: 10px;
          text-align: center;
          font-size: 13px;

          a {
            text-decoration: none;
          }
        }

        .now {
          background-color: #25b686;
          color: #fff;
          padding: 10px 30px;
          border: none;

          a {
            color: #fff;
          }
        }

        .now:hover {
          background-color: #108f65;
        }

        .soon {
          background-color: #fff;
          padding: 8px 28px;
          border: 2px solid #25b686;

          a {
            color: #25b686;
          }
        }

        .soon:hover {
          background-color: #eee;
        }

        .features {
          padding: 0 0px;

          li {
            margin-left: 20px;
            text-align: left;
            font-size: 14px;
            color: #333;
            margin-bottom: 10px;
          }        
        }
      
      }
    }

    #bottom-buttons {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 40px;

      #back-button {
        flex: 1;

        button {
          border-radius: 20px;
          padding: 8px 10px;
          background-color: #fff;
          border: 2px solid #fff;
          font-size: 16px;
          transition: background-color 0.2s;
          cursor: pointer;
          text-align: center;
          outline: none;
          color: #25b686;
        }

        button:hover {
          background-color: #eee;
        }
      }

      #forward-button {
        flex: 4;
        text-align: right;
        margin-right: 15px;

        button {
          border-radius: 3px;
          background-color: #25b686;
          color: #fff;
          padding: 10px 30px;
          border: none;
          font-size: 13px;
          transition: background-color 0.2s;
          cursor: pointer;
          text-align: center;
          outline: none;
        }

        button:hover,
        button:focus {
          background-color: #108f65;
        }
      }
    }
    .features {
      padding: 0 0;
      margin: 30px 0px 10px 0;

      h4 {
        font-size: 18px;
      }

      p {
        text-align: left;
        font-size: 14px;
        line-height: 25px;
        margin: 0;
      }
    }

    .get-ready {
      text-align: center;

      h3 {
        font-weight: 300;
        text-align: center;
        font-size: 16px;
      }

      #app-loader {
        font-size: 0.875em;
        color: white;
        background-color: transparent;
        padding: 5px;
        border-radius: 4px;
        width: 100%;
      }
      .lds-ring {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
      }
      .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #24c074;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #24c074 transparent transparent transparent;
      }
      .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
      }
      .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
      }
      .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
      }
      @keyframes lds-ring {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
}

.v-select-customized {
  margin-top: 30px !important;
  margin-bottom: -20px !important;
}

.v-text-field .v-label--active {
  max-width: 133%;
  -webkit-transform: translateY(-18px) scale(0.75);
  transform: translateY(-23px) scale(0.75) translateX(-8px) !important;
  pointer-events: auto;
}

</style>
